import { SubscribedContext } from "@/providers/Subscribed";
import { LiveTv } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

export default function LiveCard({ content }) {
  const navigate = useNavigate();
  const { isSubscribed, handleModalOpen } = useContext(SubscribedContext);

  const handleClickJoin = () => {
    if (!isSubscribed) {
      handleModalOpen();
      return;
    }
    navigate(`/${content.owner.key}/live?key=${content.key}`);
  };

  return (
    <Box>
      <Button
        variant="outlined"
        color="secondary"
        fullWidth
        style={{ marginTop: "10px" }}
        startIcon={<LiveTv />}
        onClick={handleClickJoin}
        disabled={content.meta.ended}
      >
        {content.meta.ended ? "Livestream Ended" : "Join Livestream"}
      </Button>
    </Box>
  );
}
